import { getCurrentCupboardInfo } from "./caxa/directive/getCurrentCupboardInfo.js";
import { postSplitOrderDataNew } from "./kujiale/getCurrentCupboardInfo.js";
import { ExternalType } from "./type.js";
function externalGetCurrentCupboardInfo(arg, type = ExternalType.caxa, preTest = false) {
  switch (type) {
    case ExternalType.caxa:
      return getCurrentCupboardInfo(arg);
    case ExternalType.kujiale:
      if (preTest) {
        return postSplitOrderDataNew(arg);
      } else {
        return postSplitOrderDataNew(arg);
      }
    default:
      throw new Error(`\u8BE5\u65B9\u6CD5\uFF0C\u6682\u4E0D\u652F\u6301${type}\u7C7B\u578B\u7684\u5916\u90E8\u7CFB\u7EDF`);
  }
}
export { externalGetCurrentCupboardInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/externalGetCurrentCupboardInfo.js